var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var EventEmitter = require('events').EventEmitter;

var pMap = require('p-map');

var Log = require('ipfs-log');

var Logger = require('logplease');

var logger = Logger.create('replicator', {
  color: Logger.Colors.Cyan
});
Logger.setLogLevel('ERROR');

var getNext = function getNext(e) {
  return e.next;
};

var flatMap = function flatMap(res, val) {
  return res.concat(val);
};

var notNull = function notNull(entry) {
  return entry !== null && entry !== undefined;
};

var uniqueValues = function uniqueValues(res, val) {
  res[val] = val;
  return res;
};

var batchSize = 1;

var Replicator = /*#__PURE__*/function (_EventEmitter) {
  "use strict";

  _inherits(Replicator, _EventEmitter);

  var _super = _createSuper(Replicator);

  function Replicator(store, concurrency) {
    var _this;

    _classCallCheck(this, Replicator);

    _this = _super.call(this);
    _this._store = store;
    _this._fetching = {};
    _this._stats = {
      tasksRequested: 0,
      tasksStarted: 0,
      tasksProcessed: 0
    };
    _this._buffer = [];
    _this._concurrency = concurrency || 128;
    _this._queue = {};
    _this._q = new Set(); // Flush the queue as an emergency switch

    _this._flushTimer = setInterval(function () {
      if (_this.tasksRunning === 0 && Object.keys(_this._queue).length > 0) {
        logger.warn('Had to flush the queue!', Object.keys(_this._queue).length, 'items in the queue, ', _this.tasksRequested, _this.tasksFinished, ' tasks requested/finished');
        setTimeout(function () {
          return _this._processQueue();
        }, 0);
      }
    }, 3000);
    return _this;
  }
  /**
   * Returns the number of tasks started during the life time
   * @return {[Integer]} [Number of tasks started]
   */


  _createClass(Replicator, [{
    key: "tasksRequested",
    get: function get() {
      return this._stats.tasksRequested;
    }
    /**
     * Returns the number of tasks started during the life time
     * @return {[Integer]} [Number of tasks running]
     */

  }, {
    key: "tasksStarted",
    get: function get() {
      return this._stats.tasksStarted;
    }
    /**
     * Returns the number of tasks running currently
     * @return {[Integer]} [Number of tasks running]
     */

  }, {
    key: "tasksRunning",
    get: function get() {
      return this._stats.tasksStarted - this._stats.tasksProcessed;
    }
    /**
     * Returns the number of tasks currently queued
     * @return {[Integer]} [Number of tasks queued]
     */

  }, {
    key: "tasksQueued",
    get: function get() {
      return Math.max(Object.keys(this._queue).length - this.tasksRunning, 0);
    }
    /**
     * Returns the number of tasks finished during the life time
     * @return {[Integer]} [Number of tasks finished]
     */

  }, {
    key: "tasksFinished",
    get: function get() {
      return this._stats.tasksProcessed;
    }
    /**
     * Returns the hashes currently queued
     * @return {[Array<String>]} [Queued hashes]
     */

  }, {
    key: "getQueue",
    value: function getQueue() {
      return Object.values(this._queue);
    }
    /*
      Process new heads.
     */

  }, {
    key: "load",
    value: function load(entries) {
      var _this2 = this;

      var notKnown = function notKnown(entry) {
        var hash = entry.hash || entry;
        return !_this2._store._oplog.has(hash) && !_this2._fetching[hash] && !_this2._queue[hash];
      };

      try {
        entries.filter(notNull).filter(notKnown).forEach(this._addToQueue.bind(this));
        setTimeout(function () {
          return _this2._processQueue();
        }, 0);
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      // Clears the queue flusher
      clearInterval(this._flushTimer); // Remove event listeners

      this.removeAllListeners('load.added');
      this.removeAllListeners('load.end');
      this.removeAllListeners('load.progress');
    }
  }, {
    key: "_addToQueue",
    value: function _addToQueue(entry) {
      var hash = entry.hash || entry;
      this._stats.tasksRequested += 1;
      this._queue[hash] = entry;
    }
  }, {
    key: "_processQueue",
    value: function () {
      var _processQueue2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var capacity, items, flattenAndGetUniques, processValues;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.tasksRunning < this._concurrency)) {
                  _context.next = 7;
                  break;
                }

                capacity = this._concurrency - this.tasksRunning;
                items = Object.values(this._queue).slice(0, capacity).filter(notNull);
                items.forEach(function (entry) {
                  return delete _this3._queue[entry.hash || entry];
                });

                flattenAndGetUniques = function flattenAndGetUniques(nexts) {
                  return nexts.reduce(flatMap, []).reduce(uniqueValues, {});
                };

                processValues = function processValues(nexts) {
                  var values = Object.values(nexts).filter(notNull);

                  if (items.length > 0 && _this3._buffer.length > 0 || _this3.tasksRunning === 0 && _this3._buffer.length > 0) {
                    var logs = _this3._buffer.slice();

                    _this3._buffer = [];

                    _this3.emit('load.end', logs);
                  }

                  if (values.length > 0) {
                    _this3.load(values);
                  }
                };

                return _context.abrupt("return", pMap(items, function (e) {
                  return _this3._processOne(e);
                }).then(flattenAndGetUniques).then(processValues));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _processQueue() {
        return _processQueue2.apply(this, arguments);
      }

      return _processQueue;
    }()
  }, {
    key: "_processOne",
    value: function () {
      var _processOne2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(entry) {
        var hash, exclude, log, latest;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                hash = entry.hash || entry;

                if (!(this._store._oplog.has(hash) || this._fetching[hash])) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                this._fetching[hash] = hash;
                this.emit('load.added', entry);
                this._stats.tasksStarted += 1;
                exclude = [];
                _context2.next = 9;
                return Log.fromEntryHash(this._store._ipfs, this._store.identity, hash, {
                  logId: this._store._oplog.id,
                  access: this._store.access,
                  length: batchSize,
                  exclude: exclude
                });

              case 9:
                log = _context2.sent;

                this._buffer.push(log);

                latest = log.values[0];
                delete this._queue[hash]; // Mark this task as processed

                this._stats.tasksProcessed += 1; // Notify subscribers that we made progress

                this.emit('load.progress', this._id, hash, latest, null, this._buffer.length); // Return all next pointers

                return _context2.abrupt("return", log.values.map(getNext).reduce(flatMap, []));

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _processOne(_x) {
        return _processOne2.apply(this, arguments);
      }

      return _processOne;
    }()
  }]);

  return Replicator;
}(EventEmitter);

module.exports = Replicator;